import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { useAnalytics } from "../../../../analytics/analytics";
import { ReleaseNotes } from "../../../../release-notes/release-notes";
import { AdditionalServicesSection } from "../additional-services-section";
import { ThemeAwareDivider } from "../divider";
import { DebugButton } from "./debug-button/debug-button";
import { NavHeader } from "./nav-header";
import { NavOptions } from "./nav-options";
import { NavPlannerOptions } from "./nav-planner-options";
import { NeedHelp } from "./need-help";
import { WhatsNew } from "./whats-new";

import type { NavigationProps } from "./types";
import type { FC } from "react";

export const Navigation: FC<NavigationProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const { gaEvent } = useAnalytics();

  return (
    <Stack sx={{ height: "100%" }}>
      <NavHeader onClose={onClose} />

      <Stack component="nav" spacing={2} sx={{ flexGrow: 1, px: 2 }}>
        <Button
          data-analytics-id="sidebar-home"
          fullWidth
          onClick={() => {
            onClose?.();
            gaEvent("multiformat_button", { action: "click", value: "Home" });
            void navigate({ pathname: "/" });
          }}
          variant="contained"
        >
          Home
        </Button>
        <ReleaseNotes />
        <NavOptions onNavigate={onClose} />
        <ThemeAwareDivider />
        <NavPlannerOptions onNavigate={onClose} />
        <AdditionalServicesSection />
        <DebugButton />
        <Stack direction="row" justifyContent="space-between" sx={{ px: 1, py: 3 }}>
          <NeedHelp />
          <WhatsNew />
        </Stack>
      </Stack>
    </Stack>
  );
};
